<template>
  <section>
    <!--工具条-->
    <Toolbar :buttonList="buttonList" @callFunction="callFunction" :selectBut="false"></Toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%;"
      :height="getTableHeight(165)"
    >
      <el-table-column prop="Id" width="70" fixed></el-table-column>
      <el-table-column prop="Sort" :label="$t('Sort')"></el-table-column>
      <el-table-column :label="$t('Name')" width="200">
        <template slot-scope="scope">
          <i class="fa" :class="scope.row.Icon"></i>
          {{field(scope.row.Name)}}
        </template>
      </el-table-column>
      <el-table-column prop="Remark" :label="$t('Remark')"></el-table-column>
      <el-table-column prop="Created" :label="$t('Created')" sortable>
        <template slot-scope="scope">{{ formatDate(scope.row.Created)}}</template>
      </el-table-column>
      <el-table-column prop="Modified" :label="$t('Modified')" sortable>
        <template slot-scope="scope">{{ formatDate(scope.row.Modified)}}</template>
      </el-table-column>
      <el-table-column prop="Enabled" :label="$t('Enabled')" width>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled  ? 'success' : 'danger'"
            disable-transitions
          >{{scope.row.Enabled ? $t('enabled'):$t('disable')}}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="20"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" ref="editForm">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.'+slot.langkey"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Name')}"
            >
              <el-input v-model="editForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="Sort">
              <el-input
                v-model.number="editForm.Sort"
                type="text"
                maxlength="2"
                style="width:150px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Remark')">
              <el-input type="textarea" :rows="2" v-model="editForm.Remark"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="editForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="editForm.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">{{$t('submit')}}</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.'+slot.langkey"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Name')}"
            >
              <el-input v-model="addForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="Sort">
              <el-input v-model.number="addForm.Sort" type="text" maxlength="2" style="width:150px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Remark')">
              <el-input type="textarea" :rows="2" v-model="addForm.Remark"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="addForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="addForm.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">{{$t('submit')}}</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import { getAreaListPage, removeArea, editArea, addArea } from "@/api/api";
import { getButtonList } from "@/promissionRouter";

export default {
  data() {
    return {
      filters: {
        Name: ""
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: { Name: {} },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: { Name: {} }
    };
  },
  methods: {
    formatDate: function(val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    //获取列表
    getList() {
      let para = {
        page: this.page,
        key: this.filters.Name
      };
      this.listLoading = true;
      getAreaListPage(para).then(res => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error"
        });

        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeArea(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error"
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.clone(row));
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Name: {},
        Sort: 0,
        Remark: "",
        Enabled: true
      };
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);

              editArea(para).then(res => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success"
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              para.IsDeleted = false;

              addArea(para).then(res => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }

                if (res.data.success) {
                  this.addLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success"
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    }
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
</style>
